import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import { Form, Field } from 'react-final-form';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as types from '../../../../actions/actionTypes';
import { getPricePointerData } from '../../../../actions/listing';
import TextField from '../../../utility/TextField';
import Messages, { MessagesTypes } from '../../../utility/Messages';
import validations, { composeValidators } from '../../../../lib/validation';
import { buttonStyles } from '../../../../styles/base';
import track from '../../../../lib/track';

export interface Props {
  classes: any;
  dispatch: any;
  handleZipSubmit: Function;
  messages: MessagesTypes;
  router: any;
  token: string;
  zip: string;
}

const styles = {
  form: {
    margin: '0 auto',
    maxWidth: 380,
  },
};

export class PricePointerForm extends React.Component<Props, {}> {
  handleSubmit = (values: any) => {
    if (!this.props.token) {
      this.props.dispatch({
        postAuthPath: this.props.router.asPath,
        type: types.OpenSignupDialog,
      });
    } else {
      track.toolUsed('Price Pointer', values);
      this.props.handleZipSubmit(values.zip);
      this.props.dispatch(getPricePointerData(values.zip));
    }
  };

  render() {
    const { classes, messages, zip } = this.props;
    return (
      <Form
        onSubmit={this.handleSubmit}
        initialValues={{ zip }}
        render={({ handleSubmit, values }) => (
          <form style={styles.form}>
            <div>
              <Messages messages={messages} />
              <div>
                <Field
                  name="zip"
                  type="text"
                  component={TextField}
                  label="Zip Code"
                  placeholder="#"
                  autoComplete="off"
                  validate={composeValidators(
                    validations.zipCode,
                    validations.required,
                  )}
                  fullWidth
                />
                <br />
                <br />
                <Button
                  disabled={
                    values.zip && values.zip.length === 5 ? false : true
                  }
                  variant="contained"
                  className={`${classes.buttonMediumGreen} full-width`}
                  type="submit"
                  onClick={handleSubmit}
                >
                  SUBMIT
                </Button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

const mapStateToProps = (state: any) => ({
  messages: state.messages,
  token: state.auth.token,
});

export default connect(mapStateToProps)(
  withStyles(buttonStyles)(withRouter(PricePointerForm)),
);
